import { useEffect } from "react";
import { Link } from "react-router-dom";
import useScrollAnimation from "../../hooks/useScrollAnimation";
import Navbar from "../home/components/Navbar";
import Footer from "../home/components/Footer";

const CONTACT_ITEMS = [
  {
    icon: "ri-map-pin-line",
    title: "Adres",
    lines: ["Mehmet, Adnan Menderes, Mehmet Zahid Kotku Cd no: 36/1", "80010 Osmaniye Merkez/Osmaniye"],
  },
  {
    icon: "ri-phone-line",
    title: "Telefon",
    lines: ["+90 551 183 09 18", "+90 538 302 49 39"],
  },
  {
    icon: "ri-mail-line",
    title: "E-Posta",
    lines: ["info@vipreklamdekorasyon.com", "vipreklamdekorasyon@gmail.com"],
  },
  {
    icon: "ri-time-line",
    title: "Çalışma Saatleri",
    lines: ["Pazartesi - Cumartesi", "08:00 - 18:00"],
  },
];

const IletisimPage = () => {
  useScrollAnimation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <section className="relative pt-32 pb-20 bg-[#0D0D0D] overflow-hidden">
        <div className="absolute inset-0 opacity-15">
          <img
            src="/images/menu-icin-cephe-44a1019c.png"
            alt="İletişim"
            className="w-full h-full object-cover object-center"
          />
        </div>
        <div className="absolute top-0 left-0 w-1.5 h-full bg-[#E6A800]" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">
          <div className="flex items-center gap-2 mb-6 anim-down d0">
            <Link to="/" className="text-white/40 text-xs font-head hover:text-[#E6A800] tr uppercase tracking-wider">
              Ana Sayfa
            </Link>
            <i className="ri-arrow-right-s-line text-white/30 text-xs" />
            <span className="text-[#E6A800] text-xs font-head uppercase tracking-wider">İletişim</span>
          </div>
          <div className="flex items-center gap-3 mb-5 anim-left d1">
            <div className="w-8 h-[2px] bg-[#E6A800]" />
            <span className="font-head text-[#E6A800] text-xs font-700 uppercase tracking-[0.2em]">Bize Ulaşın</span>
          </div>
          <h1 className="font-head font-black uppercase text-white text-[clamp(48px,8vw,100px)] leading-[0.88] anim-up d2">
            İletişim
            <br />
            <span className="text-[#E6A800]">Noktaları</span>
          </h1>
          <p className="text-white/75 text-base leading-relaxed max-w-2xl mt-6 anim-up d3">
            Projeniz için teklif almak, keşif planlamak veya teknik destek talep etmek
            için bize doğrudan ulaşabilirsiniz.
          </p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 mb-12">
            {CONTACT_ITEMS.map((item, i) => (
              <div
                key={item.title}
                className="border border-[#E8E8E8] hover:border-[#E6A800] p-6 tr anim-up"
                style={{ transitionDelay: `${i * 70}ms` }}
              >
                <div className="w-10 h-10 flex items-center justify-center bg-[#E6A800]/15 mb-4">
                  <i className={`${item.icon} text-[#E6A800]`} />
                </div>
                <h3 className="font-head font-700 uppercase text-[#111] text-base tracking-wide mb-3">
                  {item.title}
                </h3>
                <div className="space-y-1">
                  {item.lines.map((line) => (
                    <p key={line} className="text-[#4F4F4F] text-base leading-relaxed">
                      {line}
                    </p>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="bg-[#F7F7F7] border border-[#EAEAEA] p-8 anim-left">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-8 h-[3px] bg-[#E6A800]" />
                <span className="font-head text-[#E6A800] text-xs font-700 uppercase tracking-[0.2em]">Hızlı İletişim</span>
              </div>
              <h2 className="font-head font-black uppercase text-[#0D0D0D] text-5xl leading-[0.92] mb-5">
                Projenizi
                <br />
                <span className="text-[#E6A800]">Birlikte Başlatalım</span>
              </h2>
              <p className="text-[#555] text-base leading-relaxed mb-7">
                Osmaniye ve çevresinde ücretsiz keşif hizmeti sunuyoruz. İhtiyacınızı paylaşın,
                size en uygun çözüm ve teklif planını hazırlayalım.
              </p>

              <div className="flex flex-wrap gap-3">
                <a
                  href="tel:+905511830918"
                  className="inline-flex items-center gap-2 px-6 py-3.5 bg-[#E6A800] text-white hover:bg-[#C99500] tr font-head font-700 uppercase text-sm tracking-wider"
                >
                  <i className="ri-phone-fill" />
                  Hemen Ara
                </a>
                <a
                  href="https://wa.me/905511830918"
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="inline-flex items-center gap-2 px-6 py-3.5 bg-[#25D366]/15 border border-[#25D366]/30 text-[#25D366] hover:bg-[#25D366]/25 tr font-head font-700 uppercase text-sm tracking-wider"
                >
                  <i className="ri-whatsapp-line" />
                  WhatsApp
                </a>
                <a
                  href="https://instagram.com/vip.tasarim"
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="inline-flex items-center gap-2 px-6 py-3.5 bg-white border border-[#E6A800]/40 text-[#0D0D0D] hover:bg-[#FFF8E1] hover:border-[#E6A800] tr font-head font-700 uppercase text-sm tracking-wider"
                >
                  <i className="ri-instagram-line" />
                  @vip.tasarim
                </a>
              </div>
            </div>

            <div className="bg-[#0D0D0D] p-8 text-white anim-right d1">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-8 h-[3px] bg-[#E6A800]" />
                <span className="font-head text-[#E6A800] text-xs font-700 uppercase tracking-[0.2em]">Konum</span>
              </div>
              <h3 className="font-head font-black uppercase text-4xl leading-[0.92] mb-4">
                Osmaniye Merkez
              </h3>
              <p className="text-white/75 text-base leading-relaxed mb-6">
                Mehmet, Adnan Menderes, Mehmet Zahid Kotku Cd No: 36/1, 80010
                Osmaniye Merkez/Osmaniye adresinde hizmet veriyoruz.
              </p>

              <a
                href="https://maps.google.com/?q=Mehmet%20Adnan%20Menderes%20Mehmet%20Zahid%20Kotku%20Cd%20No%2036/1%2080010%20Osmaniye%20Merkez%20Osmaniye%20Turkey"
                target="_blank"
                rel="nofollow noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3.5 border border-white/20 hover:border-[#E6A800] hover:text-[#E6A800] tr font-head font-700 uppercase text-sm tracking-wider"
              >
                <i className="ri-map-pin-2-line" />
                Haritada Aç
              </a>

              <div className="mt-6 border border-white/15 overflow-hidden">
                <iframe
                  title="Vip Reklam Dekorasyon Konum"
                  src="https://www.google.com/maps?q=Mehmet%20Adnan%20Menderes%20Mehmet%20Zahid%20Kotku%20Cd%20No%2036/1%2080010%20Osmaniye%20Merkez%20Osmaniye%20Turkey&output=embed"
                  width="100%"
                  height="280"
                  style={{ border: 0 }}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default IletisimPage;
